module.exports = __webpack_public_path__ + "static/media/Bg1.4227c50c.svg";